// extracted by mini-css-extract-plugin
export default {"confirmBackPopup":"ConfirmBackPopup_confirmBackPopup__SS5rR"};